// extracted by mini-css-extract-plugin
export default {"wrapper":"font-and-typography_wrapper__hQgvD","filePreview":"font-and-typography_filePreview__JDJwt","uploadFontModalContent":"font-and-typography_uploadFontModalContent__6-EH7"};